import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import InquiryForm from './InquiryForm';

const GetUserInfoQuery = gql`
  query InquiryFormUserInfo {
    userInfo {
      invoiceFirstName
      invoiceLastName
      email
      phone
    }
  }
`;

const SendInquiryForm = gql`
  mutation inquiryForm($data: InquiryFormInput, $countryCode: String!) {
    inquiryForm(data: $data, countryCode: $countryCode) {
      result
    }
  }
`;

interface IInputProps {
  children?: any;
  data: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(GetUserInfoQuery, { 
    name: 'userInfo',
    options: { fetchPolicy: 'cache-and-network' } 
  }),
  graphql<IInputProps, IResponse>(SendInquiryForm, {
    name: 'inquiryForm'
  })
)(InquiryForm);



// WEBPACK FOOTER //
// ./src/components/InquiryForm/index.tsx